<div>
    <div class="row"
      style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important">
      <div class="col-11"></div>
      <div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;">
        <mat-icon style="float:right; cursor: pointer;" (click)="onNoClick()">cancel</mat-icon>
      </div>
    </div>
    <h1 mat-dialog-title>Brisanje za "{{data.filename}}"</h1>
    <div mat-dialog-content>
      <p>
        {{labels.lblDeleteDocumentMessage}}
      </p>
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-12 align-items-center" style="display: flex" >
            <button mat-raised-button color="primary" (click)="deleteFile()">{{labels.lblDelete}}</button>
            <button mat-raised-button color="warn" (click)="onNoClick()">{{labels.lblCancel}}</button>
          </div>
        </div>
      </div>
     </div>
  </div>


